export const CORPAY_SSO_CONTAINER_TAG_NAME = 'corpay-sso-container';
